
import Swiper from 'swiper/swiper-bundle.min.mjs'
import 'swiper/swiper-bundle.css'

export default {
  props: {
    swiperList: {
      type: Array,
      deafult: () => {
        return []
      }
    },
  },
  data() {
    return {
      swiper: {},
      imageList: [],
    }
  },
  watch: {
    swiperList: {
      immediate: true,
      handler: function(val) {
        if (val.length == 0) return

        this.initImageList()
      }
    }
  },
  methods: {
    // 设置图片为加载状态
    initImageList() {
      const imageList = []
      for (let i = 0; i < this.swiperList.length; i++) {
        imageList.push({
          loading: true,
          url: this.swiperList[i]
        })
      }
      this.imageList = imageList

      this.initSwiper()
    },
    // 图片加载完成后取消加载状态
    handleLoad(img) {
      this.$set(img, 'loading', false)
    },
    initSwiper() {
      this.$nextTick(() => {
        this.swiper = new Swiper('#imageSwiper', {
          direction: 'horizontal',
          loop: true,
          autoplay: {
            delay: 3000,
            disableOnInteraction: false,
          },
          pagination: {
            el: '.swiper-pagination',
            bulletClass: 'swiper-pagination__btn',
            bulletActiveClass: 'swiper-pagination--active',
            clickable: true,
            renderBullet: function (index, className) {
              return '<div class="' + className + '"></div>'
            }
          },
        })
      })
    }
  }
}